import type { QueryFunctionContext } from '@tanstack/react-query';
import { gql } from '@/utilities/gql';

import { gqlClient } from '@/utilities/graphQLClient';

import { NOTE_FRAGMENT } from './note-fragment';
import type { NoteFragmentType } from './note-fragment';

export interface QueryResponse {
  errors?: Error[];
  Note: NoteFragmentType;
}

type QueryContext = QueryFunctionContext<[string, string | undefined]>;

export const queryFn = async ({ queryKey: [_, noteId] }: QueryContext) => {
  if (typeof noteId === 'undefined') {
    return Promise.reject(new Error('Invalid note id'));
  }
  const { Note, errors } = await gqlClient.request(
    gql(
      `
      query getNote($noteId: String!) {
        Note(noteId: $noteId) {
          ...NoteFields
        }
      }
    `,
      [NOTE_FRAGMENT]
    ),
    { noteId }
  );

  if (errors?.length) {
    const [firstError] = errors;
    throw new Error(firstError.message);
  }

  return Note;
};
